import axios from "axios";
// import moment from 'moment';
import config from "./config";
// import gaPush from './utils/google-analytics';
import store from "../store";
// import appLogout from '../actions/app-logout';
import clearStorage from "../actions/clear-storage";
import { gapi } from "gapi-script";
console.log(store);
const { dispatch } = store;

export const GA_EVENT_TIMING = "timing";

const googleClientID = "" + process.env.REACT_APP_GOOGLE_CLIENT_ID + "";

export default {
  /* eslint-disable */

  login: ({
    //  email, google_user_id, username, tokenId,
    targetUrl,
    clientId,
    credential,
    select_by,
  }) =>
    getInstrumentedAxiosInstance("login", null, credential).post(targetUrl, {
      // email: email,
      // google_user_id: google_user_id,
      // username: username,
      select_by: select_by,
    }),

  appLogout: ({ url }) =>
    getInstrumentedAxiosInstance("logout")
      .put(url)
      .then((response) => response),

  dataLoad: ({ key, url }) =>
    getInstrumentedAxiosInstance(`Data load ${key}`)
      .get(url)
      .then((dataResponse) => {
        switch (key) {
          // case 'customer': {
          //   return dataResponse.data._embedded.customers
          //     // flatten array of sales
          //     .map(item => ({
          //       href: item._links.self.href,
          //       fullName: item.full_name,
          //       phone: item.customer_phone,
          //       lowerCaseName: item.full_name.toLowerCase(),
          //       initials: item.initials,
          //     }));
          // }
          case "login":
          default:
            return dataResponse;
        }
      }),
  webPushSubscribe: ({ subscription, targetUrl }) =>
    getInstrumentedAxiosInstance("Push subscribe").post(targetUrl, {
      subscription,
    }),
  webPushUnsubscribe: ({ subscription, targetUrl }) =>
    getInstrumentedAxiosInstance("Push subscribe").post(targetUrl, {
      subscription,
    }),
};

async function loggedInUserValidity() {
  // console.log('googleClientID', googleClientID);
  const client_id = googleClientID;

  const initSigninV2 = () => {
    gapi.auth2
      .init({
        client_id: client_id,
      })
      .then((res) => {
        // now auth2 is fully initialized
        // console.log('auth2 init success', res);
        console.log("isSignedIn====>", res.isSignedIn.le); //now this always returns correctly
        console.log("props inside ==>", history);
        if (!res.isSignedIn.le) {
          // this.props.history.push({
          //   pathname: '/login',
          // });
          window.localStorage.clear();
          window.location.reload();
          window.location.replace("/login");
        }
      });
  };
  gapi.load("auth2", initSigninV2);
  // let auth2 = await loadAuth2(gapi, client_id);
}

function getAxiosInstance(axiosConfig, tokenId) {
  console.log("sldfdkf", axiosConfig, tokenId);
  // loggedInUserValidity();
  return axios.create({
    baseURL: config.apiContextPath,
    headers: {
      Accept: "application/hal+json",
      "Content-Type": "application/json",
      authorization: tokenId,
      // 'Accept-Language': locale,
    },
    ...axiosConfig,
  });
}

export const getInstrumentedAxiosInstance = (
  timingVar,
  axiosConfig,
  tokenId
) => {
  console.log("xxxx", timingVar, axiosConfig, tokenId);
  const state = store.getState();
  // const { locale } = state.user;
  // console.log('state<><><><>', state);
  const instance = getAxiosInstance(axiosConfig, tokenId);
  let startTime;
  let duration;

  instance.interceptors.request.use(
    (interceptorConfig) => {
      // console.log('in interceptor request redux', interceptorConfig.url);
      /* eslint-disable */
      // const url = interceptorConfig.url.split('/').pop();
      // if (url !== 'loginotprequest') {
      //   interceptorConfig.withCredentials = true;
      // }
      const token = localStorage.getItem("token");
      // console.log('token >>>', token)
      if (token) {
        interceptorConfig.headers["authorization"] = token;
        const persistedState = JSON.parse(localStorage.getItem("redux_state"));
        if (
          persistedState &&
          persistedState.user &&
          persistedState.user.settings_data &&
          persistedState.user.settings_data.DIGITAL_ORDER_SYSTEM
        ) {
          interceptorConfig.headers["X-SYS"] =
            persistedState.user.settings_data.DIGITAL_ORDER_SYSTEM;
        }
      }
      // interceptorConfig.withCredentials = true;
      startTime = new Date().getTime();
      return interceptorConfig;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      duration = new Date().getTime() - startTime;
      // gaRecordTiming(gaPush, timingVar, duration, response.status);
      if (response.data.data && response.data.data._token) {
        localStorage.setItem("token", response.data.data._token);
        // dispatch(appLogout());
        console.log("in interceptor reponse redux 111", response);
      }
      return response;
    },
    (error) => {
      console.log("in interceptor reponse redux", error);
      if (error && error.response && error.response.status === 401) {
        console.log("in 401", error.response);
        dispatch(clearStorage());
        window.location.replace("/login");
        window.localStorage.clear();
      }
      duration = new Date().getTime() - startTime;
      // gaRecordTiming(gaPush, timingVar, duration, error.response ? error.response.status : 999);
      return Promise.reject(error);
    }
  );

  return instance;
};

// export function gaRecordTiming(gaPushAction, timingVar, duration, status) {
//   gaPushAction(GA_EVENT_TIMING, {
//     category: 'Network',
//     variable: timingVar,
//     value: duration,
//     label: status.toString(),
//   });
// }
